var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIceHockey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_6809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.44406 1.11647C4.33067 0.863062 4.07867 0.700124 3.80113 0.700593L0.701986 0.705609C0.467892 0.705984 0.249361 0.822843 0.119002 1.01733C-0.0113109 1.21176 -0.0362484 1.45833 0.0523453 1.67498L0.806564 3.51806H5.51891L4.44406 1.11647Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14809 4.92441H1.38184L1.89976 6.19008H6.71452L6.14809 4.92441Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1164 16.5494L17.8429 15.3188C17.7714 14.997 17.4861 14.7682 17.1565 14.7682H11.5553C10.919 14.7682 10.3942 14.4111 10.1156 13.7885L7.34426 7.59633H2.47559L6.33171 17.0195C7.1832 19.1005 9.06195 20.3932 11.2348 20.3932H12.9376V19.4557C12.9376 17.8531 14.2414 16.5494 15.8439 16.5494H18.1164Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.9557H15.8438C15.0166 17.9557 14.3438 18.6285 14.3438 19.4557V21.7994C14.3438 22.6265 15.0166 23.2994 15.8438 23.2994H22.5C23.3271 23.2994 24 22.6265 24 21.7994V19.4557C24 18.6285 23.3271 17.9557 22.5 17.9557Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_6809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceHockey);
export default __webpack_public_path__ + "static/media/ice_hockey.7fcd1d78eb62020d61a53efa91b469d0.svg";
export { ForwardRef as ReactComponent };